import { render, staticRenderFns } from "./PageFooter.vue?vue&type=template&id=24ef88b5&scoped=true"
import script from "./PageFooter.vue?vue&type=script&lang=js"
export * from "./PageFooter.vue?vue&type=script&lang=js"
import style0 from "./PageFooter.vue?vue&type=style&index=0&id=24ef88b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ef88b5",
  null
  
)

export default component.exports